import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DropzoneComponent from '../common/dropzone.component';
import { fetchParsedMappingFile } from '../../store/actions/metadata.actions';

class MappingUploadContainer extends React.Component {
  constructor(props) {
    super(props);

    this.onFileChange = this.onFileChange.bind(this);
  }

  onFileChange(file, callback) {
    this.props.fetchParsedMappingFile(file, () => {
      callback();
    });
  }

  render() {
    return (
      <DropzoneComponent
        text="Click to select mapping file, or drag and drop"
        width="full"
        onFileChange={this.onFileChange}
        isProcessing={this.props.isFetchingMapping}
      />
    );
  }
}

MappingUploadContainer.propTypes = {
  isFetchingMapping: PropTypes.bool.isRequired,
  fetchParsedMappingFile: PropTypes.func.isRequired,
};

const mapStateToProps = ({ status: { isFetchingMapping } }) => ({
  isFetchingMapping,
});

export default connect(mapStateToProps, { fetchParsedMappingFile })(MappingUploadContainer);
